unit OtherClaimsConnectedCharitiesList;
interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, ClaimScopedList, WEBLib.ExtCtrls, WEBLib.Actions,
  Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls, Vcl.Controls, WEBLib.Lists,
  smx.webcore.types;

type
  TOtherClaimsConnectedCharitiesListForm = class(TClaimScopedListForm)
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetExternalId: TStringField;
    MainDatasetTransactionDate: TDateField;
    MainDatasetImportId: TIntegerField;
    MainDatasetClaimId: TIntegerField;
    MainDatasetGiftAid: TFloatField;
    MainDatasetAmount: TFloatField;
    MainDatasetClaimStatus: TStringField;
    MainDatasetClaimDate: TDateTimeField;
    MainDatasetTaxYear: TIntegerField;
    MainDatasetErrorText: TStringField;
    MainDatasetCharityTenant: TStringField;
    MainDatasetSourceType: TStringField;
    MainDatasetComment: TStringField;
    MainDatasetConnectedCharityId: TIntegerField;
    ConnectedCharityDataSet: TXDataWebDataSet;
    RefreshTimer: TTimer;
    MainDatasetCharityName: TStringField;
    procedure AddButtonClick(Sender: TObject);
    procedure DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
        AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure MainDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure MainDatasetCalcFields(DataSet: TDataSet);
    procedure RefreshTimerTimer(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
    [async]
    procedure EditForm(RecordId: integer); async;
    procedure CancelSelectedRecord(RecordId: integer);

    procedure RefreshControls;
  protected
    procedure PrepareForm; override;
    function InitSortCol: Integer; override;
    function InitSortDirection: TSortDirection; override;
    function CreateGridInFormCreate: boolean; override;
    procedure LoadData; override;
    procedure GetConnectedCharityNameFromId(CharityID: integer; var CharityName: string);

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  OtherClaimsConnectedCharitiesListForm: TOtherClaimsConnectedCharitiesListForm;

implementation

{$R *.dfm}

{ TOtherClaimsConnectedCharitiesListForm }

uses
  OtherClaimsConnectedCharitiesEdit, MainDataModule, WEBLib.WebCtrls, SMX.Web.Layout.Utils,
  XData.Web.Client, SMX.Web.Utils;



procedure TOtherClaimsConnectedCharitiesListForm.AddButtonClick(Sender:
    TObject);
begin
  inherited;
  EditForm(0);
end;

procedure TOtherClaimsConnectedCharitiesListForm.DataTableGetCellChildren(
    Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
    AElement: TJSHTMLElementRecord);
var
  RecordId: integer;
  Span: THTMLSpan;


  procedure EditClick(Sender: TObject);
  begin
    EditForm(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

  procedure CancelClick(Sender: TObject);
  begin
    CancelSelectedRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

begin
  if ARow = 0 then
    Exit;


  if not ((DataTable.Columns[ACol].Title = 'Actions')) then
  begin
    Exit;
  end;

  RecordId := MainDataSet.FieldByName('Id').AsInteger;

  if (MainDataSet.FieldByName('ClaimStatus').AsString = 'Unclaimed') or
     (MainDataSet.FieldByName('ClaimStatus').AsString = 'Invalid') then
  begin
    Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-edit', 'Edit');
    TLayoutUtils.SetActionRecordId(Span, RecordId);
    Span.OnClick := @EditClick;

    Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-trash', 'Cancel');
    TLayoutUtils.SetActionRecordId(Span, RecordId);
    Span.OnClick := @CancelClick;
  end;
end;

procedure TOtherClaimsConnectedCharitiesListForm.PrepareForm;
begin
  FIdField := 'Id';
  MainDataSet.Active := true;

  ConnectedCharityDataSet.QueryString := '$filter=CharityName ne '''' &$orderby=CharityName ASC';
  ConnectedCharityDataSet.Load;
end;

procedure TOtherClaimsConnectedCharitiesListForm.RefreshControls;
begin
  if FClaimId > 0 then
    FGridPlugin.SetPreparedFilter(CombineFilter(''))
  else
    FGridPlugin.SetPreparedFilter('ClaimStatus eq Unclaimed');
end;

procedure TOtherClaimsConnectedCharitiesListForm.EditForm(RecordId: integer);
var
  AForm: TOtherClaimsConnectedCharitiesEditForm;

begin
  AForm := TOtherClaimsConnectedCharitiesEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    await(TForm, AForm.Load());

    if RecordId = 0 then
      MainDataset.Insert
    else
    begin
      if not MainDataset.Locate('Id', RecordId, []) then
      begin
        ShowMessage('The selected record could not be found. Please refresh the list and try again.');
        Exit;
      end;
      MainDataset.Edit;
    end;
    AForm.DataSet := MainDataset;

    AForm.ConnectedCharityDataSet := ConnectedCharityDataSet;
    AForm.AfterCreated;
    await(TModalResult, AForm.Execute);
  finally
    if AForm.EditDataApplyUpdates then
    begin
      MainDataSet.ApplyUpdates;
    end;
    AForm.Free;
    AForm := nil;
  end;
end;

procedure TOtherClaimsConnectedCharitiesListForm.GetConnectedCharityNameFromId(
  CharityID: integer; var CharityName: string);
begin
  if CharityId > 0 then
  begin
    if ConnectedCharityDataSet.Locate('Id', CharityId, []) then
    begin
      CharityName := ConnectedCharityDataSet.FieldByName('CharityName').AsString;
    end;
  end
  else
  begin
    CharityName := 'Unknown';
  end;
end;

procedure TOtherClaimsConnectedCharitiesListForm.MainDatasetAfterApplyUpdates(
    Sender: TDataSet; Info: TResolveResults);
begin
  inherited;
  RefreshControls;
end;

procedure TOtherClaimsConnectedCharitiesListForm.RefreshTimerTimer(Sender:
    TObject);
begin
  RefreshTimer.Enabled := false;
  RefreshControls;
end;

procedure TOtherClaimsConnectedCharitiesListForm.LoadData;
begin
  CreateGridPlugin;
  RefreshControls;
end;

function TOtherClaimsConnectedCharitiesListForm.InitSortCol: Integer;
begin
  Result := 0;
end;

function TOtherClaimsConnectedCharitiesListForm.InitSortDirection: TSortDirection;
begin
  Result := sdDesc;
end;

procedure TOtherClaimsConnectedCharitiesListForm.CancelSelectedRecord(RecordId: integer);
begin
  if MainDataSet.Locate('Id', RecordId, []) then
  begin
    try
      MainDataSet.Edit;
      MainDataSet.FieldByName('ClaimStatus').AsString := 'Cancelled';
      MainDataSet.Post;
    finally
      MainDataSet.ApplyUpdates;
    end;
  end;
end;

function TOtherClaimsConnectedCharitiesListForm.CreateGridInFormCreate: boolean;
begin
  result := false;
end;

procedure TOtherClaimsConnectedCharitiesListForm.MainDatasetCalcFields(DataSet:
    TDataSet);
var
  CharityId: integer;
  CharityName: string;
begin
  inherited;
  CharityId := MainDataset.FieldByName('ConnectedCharityId').AsInteger;
  GetConnectedCharityNameFromId(CharityId, CharityName);
  MainDatasetCharityName.Value := CharityName;
end;

procedure TOtherClaimsConnectedCharitiesListForm.WebFormShow(Sender: TObject);
begin
  inherited;
  LoadData;
end;

procedure TOtherClaimsConnectedCharitiesListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetExternalId := TStringField.Create(Self);
  MainDatasetTransactionDate := TDateField.Create(Self);
  MainDatasetImportId := TIntegerField.Create(Self);
  MainDatasetClaimId := TIntegerField.Create(Self);
  MainDatasetGiftAid := TFloatField.Create(Self);
  MainDatasetAmount := TFloatField.Create(Self);
  MainDatasetClaimStatus := TStringField.Create(Self);
  MainDatasetClaimDate := TDateTimeField.Create(Self);
  MainDatasetTaxYear := TIntegerField.Create(Self);
  MainDatasetErrorText := TStringField.Create(Self);
  MainDatasetCharityTenant := TStringField.Create(Self);
  MainDatasetSourceType := TStringField.Create(Self);
  MainDatasetComment := TStringField.Create(Self);
  MainDatasetConnectedCharityId := TIntegerField.Create(Self);
  MainDatasetCharityName := TStringField.Create(Self);
  ConnectedCharityDataSet := TXDataWebDataSet.Create(Self);
  RefreshTimer := TTimer.Create(Self);

  DataTable.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetExternalId.BeforeLoadDFMValues;
  MainDatasetTransactionDate.BeforeLoadDFMValues;
  MainDatasetImportId.BeforeLoadDFMValues;
  MainDatasetClaimId.BeforeLoadDFMValues;
  MainDatasetGiftAid.BeforeLoadDFMValues;
  MainDatasetAmount.BeforeLoadDFMValues;
  MainDatasetClaimStatus.BeforeLoadDFMValues;
  MainDatasetClaimDate.BeforeLoadDFMValues;
  MainDatasetTaxYear.BeforeLoadDFMValues;
  MainDatasetErrorText.BeforeLoadDFMValues;
  MainDatasetCharityTenant.BeforeLoadDFMValues;
  MainDatasetSourceType.BeforeLoadDFMValues;
  MainDatasetComment.BeforeLoadDFMValues;
  MainDatasetConnectedCharityId.BeforeLoadDFMValues;
  MainDatasetCharityName.BeforeLoadDFMValues;
  ConnectedCharityDataSet.BeforeLoadDFMValues;
  RefreshTimer.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'TransactionDate';
      Title := 'Transaction Date';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'CharityName';
      Title := 'Charity Name';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Amount';
      Title := 'Amount';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ClaimStatus';
      Title := 'Claim Status';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Comment';
      Title := 'Comment';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    MainDataset.AfterApplyUpdates := MainDatasetAfterApplyUpdates;
    SetEvent(MainDataset, Self, 'OnCalcFields', 'MainDatasetCalcFields');
    MainDataset.EntitySetName := 'ConnectedCharityClaim';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetExternalId.SetParentComponent(MainDataset);
    MainDatasetExternalId.Name := 'MainDatasetExternalId';
    MainDatasetExternalId.FieldName := 'ExternalId';
    MainDatasetExternalId.Size := 64;
    MainDatasetTransactionDate.SetParentComponent(MainDataset);
    MainDatasetTransactionDate.Name := 'MainDatasetTransactionDate';
    MainDatasetTransactionDate.FieldName := 'TransactionDate';
    MainDatasetImportId.SetParentComponent(MainDataset);
    MainDatasetImportId.Name := 'MainDatasetImportId';
    MainDatasetImportId.FieldName := 'ImportId';
    MainDatasetClaimId.SetParentComponent(MainDataset);
    MainDatasetClaimId.Name := 'MainDatasetClaimId';
    MainDatasetClaimId.FieldName := 'ClaimId';
    MainDatasetGiftAid.SetParentComponent(MainDataset);
    MainDatasetGiftAid.Name := 'MainDatasetGiftAid';
    MainDatasetGiftAid.FieldName := 'GiftAid';
    MainDatasetAmount.SetParentComponent(MainDataset);
    MainDatasetAmount.Name := 'MainDatasetAmount';
    MainDatasetAmount.FieldName := 'Amount';
    MainDatasetClaimStatus.SetParentComponent(MainDataset);
    MainDatasetClaimStatus.Name := 'MainDatasetClaimStatus';
    MainDatasetClaimStatus.FieldName := 'ClaimStatus';
    MainDatasetClaimStatus.Size := 10;
    MainDatasetClaimDate.SetParentComponent(MainDataset);
    MainDatasetClaimDate.Name := 'MainDatasetClaimDate';
    MainDatasetClaimDate.FieldName := 'ClaimDate';
    MainDatasetTaxYear.SetParentComponent(MainDataset);
    MainDatasetTaxYear.Name := 'MainDatasetTaxYear';
    MainDatasetTaxYear.FieldName := 'TaxYear';
    MainDatasetErrorText.SetParentComponent(MainDataset);
    MainDatasetErrorText.Name := 'MainDatasetErrorText';
    MainDatasetErrorText.FieldName := 'ErrorText';
    MainDatasetErrorText.Size := 1000;
    MainDatasetCharityTenant.SetParentComponent(MainDataset);
    MainDatasetCharityTenant.Name := 'MainDatasetCharityTenant';
    MainDatasetCharityTenant.FieldName := 'CharityTenant';
    MainDatasetSourceType.SetParentComponent(MainDataset);
    MainDatasetSourceType.Name := 'MainDatasetSourceType';
    MainDatasetSourceType.FieldName := 'SourceType';
    MainDatasetSourceType.Size := 9;
    MainDatasetComment.SetParentComponent(MainDataset);
    MainDatasetComment.Name := 'MainDatasetComment';
    MainDatasetComment.FieldName := 'Comment';
    MainDatasetComment.Size := 250;
    MainDatasetConnectedCharityId.SetParentComponent(MainDataset);
    MainDatasetConnectedCharityId.Name := 'MainDatasetConnectedCharityId';
    MainDatasetConnectedCharityId.FieldName := 'ConnectedCharityId';
    MainDatasetCharityName.SetParentComponent(MainDataset);
    MainDatasetCharityName.Name := 'MainDatasetCharityName';
    MainDatasetCharityName.FieldKind := fkCalculated;
    MainDatasetCharityName.FieldName := 'CharityName';
    MainDatasetCharityName.Size := 255;
    MainDatasetCharityName.Calculated := True;
    ConnectedCharityDataSet.SetParentComponent(Self);
    ConnectedCharityDataSet.Name := 'ConnectedCharityDataSet';
    ConnectedCharityDataSet.EntitySetName := 'ConnectedCharity';
    ConnectedCharityDataSet.Connection := MainData.DataConnection;
    ConnectedCharityDataSet.Left := 584;
    ConnectedCharityDataSet.Top := 120;
    RefreshTimer.SetParentComponent(Self);
    RefreshTimer.Name := 'RefreshTimer';
    RefreshTimer.Enabled := False;
    SetEvent(RefreshTimer, Self, 'OnTimer', 'RefreshTimerTimer');
    RefreshTimer.Left := 576;
    RefreshTimer.Top := 16;
  finally
    DataTable.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetExternalId.AfterLoadDFMValues;
    MainDatasetTransactionDate.AfterLoadDFMValues;
    MainDatasetImportId.AfterLoadDFMValues;
    MainDatasetClaimId.AfterLoadDFMValues;
    MainDatasetGiftAid.AfterLoadDFMValues;
    MainDatasetAmount.AfterLoadDFMValues;
    MainDatasetClaimStatus.AfterLoadDFMValues;
    MainDatasetClaimDate.AfterLoadDFMValues;
    MainDatasetTaxYear.AfterLoadDFMValues;
    MainDatasetErrorText.AfterLoadDFMValues;
    MainDatasetCharityTenant.AfterLoadDFMValues;
    MainDatasetSourceType.AfterLoadDFMValues;
    MainDatasetComment.AfterLoadDFMValues;
    MainDatasetConnectedCharityId.AfterLoadDFMValues;
    MainDatasetCharityName.AfterLoadDFMValues;
    ConnectedCharityDataSet.AfterLoadDFMValues;
    RefreshTimer.AfterLoadDFMValues;
  end;
end;

end.
